module.exports = __webpack_public_path__ + "img/window-frame-open.ac0f3464.svg";